<template>
  <div class="pagination">
    <div v-if="isSimple" style="width: fit-content; flex: none">共{{ pagination.total }}条</div>
    <div class="total-text" v-else>每页</div>
    <a-pagination
      v-model="pagination.current"
      :pageSize.sync="pagination.pageSize"
      :simple="isSimple"
      :size="isSimple ? 'small' : ''"
      show-size-changer
      class="pagination-complete"
      :total="pagination.total"
      :defaultCurrent="pagination.current"
      :defaultPageSize="pagination.pageSize"
      :pageSizeOptions="pageSizeOptions"
      :item-render="itemRender"
      :showTotal="showTotal"
      @change="onChange"
      @showSizeChange="sizeChange"
      @pressEnter="sizeChange"
    >
      <template slot="buildOptionText" slot-scope="props">
        <div class="props-text">{{ props.value }}</div>
      </template>
    </a-pagination>
  </div>
</template>

<script>
import { readLocal } from '@/view/public/common'

export default {
  // 分页组件
  name: 'pagination',
  props: {
    // 是否开启简单模式
    simple: {
      type: Boolean,
      default: false
    },
    // 指定每页可以显示多少条
    pageSizeOptions: {
      type: Array,
      default: () => ['20', '50', '100']
    },
    // 分页
    pageparm: {
      type: Object,
      default: () => ({
        current: 1,
        pageSize: 20,
        total: 0
      })
    }
  },

  computed: {
    // 是否开启简单模式
    isSimple() {
      return readLocal('client') === 'APP' || this.simple
    },

    // 分页数
    pagination: {
      get() {
        return this.pageparm
      },
      set(val) {
        this.$emit('update:pageparm', val)
        return val
      }
    }
  },

  methods: {
    // 页码改变的回调，参数是改变后的页码及每页条数
    onChange(current, pageSize) {
      this.$emit('update:pageparm', {
        current,
        pageSize,
        total: this.pageparm.total
      })
      this.$emit('change')
    },

    // pageSize 变化的回调
    sizeChange(current, pageSize) {
      this.$emit('update:pageparm', {
        current: 1,
        pageSize,
        total: this.pageparm.total
      })
      this.$emit('change')
    },

    // 用于自定义页码的结构，可用于优化 SEO
    itemRender(current, type, originalElement) {
      if (type === 'page') {
        return <a>{current === 0 ? 0 : current}</a>
      }
      if (type === 'prev') {
        return (
          <a>
            <a-icon type="left" />
            {!this.isSimple ? '上一页' : ''}
          </a>
        )
      } else if (type === 'next') {
        return (
          <a>
            {!this.isSimple ? '下一页' : ''}
            <a-icon type="right" />
          </a>
        )
      }
      return originalElement
    },

    // 用于显示数据总量和当前数据顺序
    showTotal(total) {
      return `，共${total}条`
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0 0;
  padding: 0 10px;

  .total-text {
    width: 35px;
  }

  .props-text {
    width: 45px;
    text-align: left;
  }
}

/deep/ .pagination-complete {
  width: 100%;
  text-align: right;
  position: relative;

  .ant-pagination-simple-pager {
    input {
      margin: 0;
      padding: 0;
    }

    .ant-pagination-slash {
      margin: 0 5px;
    }
  }

  .ant-select-arrow {
    //margin-top: -2.5px;
  }

  .ant-pagination-prev {
    margin-right: 8px !important;
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    border: 1px solid #d9d9d9;
    padding: 0 10px;
  }

  .ant-pagination-options {
    margin-left: 0;
    position: absolute;
    left: 0;
  }

  .ant-pagination-total-text {
    position: absolute;
    left: 90px;
  }

  .ant-pagination-disabled {
    background: #f5f5f5;
  }

  .ant-pagination-item-active {
    background: #4979ff;
    color: #fff !important;

    a {
      color: #fff;
    }
  }

  //.anticon {
  //  transform: translate(-0.5px, -2.8px);
  //}
  //
  //.ant-select-arrow-icon {
  //  transform: translate(-0.5px, -0.8px);
  //}

  .ant-pagination-item-container {
    max-width: 32px;
  }
}

// 媒体查询
@media screen and (max-width: 768px) {
  .pagination {
    margin: 10px 0 0;
  }

  .total-text,
  /deep/ .ant-pagination-total-text,
  /deep/ .ant-pagination-options {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pagination/index.vue